import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { StyledTableCell } from '../../styled.js';
import 'react';
import { ReactComponent as ForwardRef } from '../../../../assets/icons/DragHandlerSmall.svg.js';

const DragHandleCell = styled(StyledTableCell, {
    shouldForwardProp: prop => prop !== 'isHighlighted' && prop !== 'isDragging',
})(({ isHighlighted, isDragging }) => (Object.assign(Object.assign({ svg: { visibility: isHighlighted ? 'visible' : 'hidden' } }, (isHighlighted && {
    cursor: 'grab',
})), (isDragging && { cursor: 'grabbing' }))));
const RowDragHandleCell = ({ row, isDragging, attributes, listeners, }) => {
    const isHighlighted = row.isHighlighted();
    return (jsx(DragHandleCell, Object.assign({ width: 0, isHighlighted: isHighlighted, isDragging: isDragging, isDisabled: false }, attributes, listeners, { children: jsx(ForwardRef, {}) })));
};

export { RowDragHandleCell as default };
//# sourceMappingURL=RowDragHandleCell.js.map
